/**
 * JQuery
 */

import $ from "jquery";

window.jQuery = $;
window.$ = $;

/**
 * Bootstrap
 */

import {
// Alert,       // Dismissible alerts
// Button,      // Toggle button states
// Carousel,    // Slideshow component
Collapse,    // Accordion-like collapsing elements
Dropdown,    // Dropdown menus
Modal,       // Popup modals
Offcanvas,   // Offcanvas sidebars
// Popover,     // Pop-up content on hover/click (requires @popperjs/core)
// ScrollSpy,   // Auto-updating navigation based on scroll position
// Tab,         // Tabs and pills navigation
// Toast,       // Small pop-up notifications
// Tooltip      // Tooltips for elements (requires @popperjs/core)
} from "bootstrap";

/**
 * Swiper
 */

import Swiper from "swiper/bundle";
import "swiper/css/bundle";
window.Swiper = Swiper;

/**
 * Slick
 */

import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

/**
 * Moduels 
 */

import productCheckout from "./js/productCheckout";
productCheckout();

import sectionPreloader from "./js/sectionPreloader";
sectionPreloader();

import shopProductsFilter from "./js/shopProductsFilter";
shopProductsFilter();

import templateFAQ from "./js/templateFAQ";
templateFAQ();

import templateQrScanner from "./js/templateQrScanner";
templateQrScanner();

import themeLayout from "./js/themeLayout";
themeLayout();

import themeSliders from "./js/themeSliders";
themeSliders();

const privacy = document.getElementById("privacy");
if (privacy) {
  privacy.addEventListener("change", () => {
    const label = privacy.parentElement;
    label.classList.toggle("checked");
  });
}
